import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIRouterModule } from '@uirouter/angular';
import { RatePlanningFeatureComponent } from '../rate-planning/rate-planning-feature/rate-planning-feature.component';
import { SharedModule } from '../shared/shared.module';
import { IndirectRateContainerComponent } from './indirect-rate-container/indirect-rate-container.component';
import {
    IndirectRateCostCenterComponent,
    IndirectRateCostCenterContainerComponent
} from './indirect-rate-cost-center';
import { IndirectRateHistoryContainerComponent } from './indirect-rate-history/indirect-rate-history-container/indirect-rate-history-container.component';
import { IndirectRateHistoryPresenter } from './indirect-rate-history/indirect-rate-history-presenter/indirect-rate-history-presenter.component';
import {
    IndirectRateManagementContainerComponent,
    IndirectRateManagementPresenterComponent
} from './indirect-rate-management';
import {
    IndirectRateReviewContainerComponent,
    IndirectRateReviewPresenter
} from './indirect-rate-review';
import {
    IndirectRateRuleComponent,
    IndirectRateRuleContainerComponent
} from './indirect-rate-rule';
import {
    IndirectRateStructureComponent,
    IndirectRateStructureContainerComponent
} from './indirect-rate-structure';
import {
    IndirectRateHistoryRoute,
    IndirectRateManagementRoute,
    IndirectRateRoute
} from './indirect-rate.route';
import { IndirectRateComponent } from './indirect-rate/indirect-rate.component';
import { IndirectContainerComponent, IndirectRoute } from './indirect.route';
import { IndirectRateCostCenterEffects } from './store/indirect-rate-cost-center/indirect-rate-cost-center.effects';
import * as fromIndirectRateCostCenter from './store/indirect-rate-cost-center/indirect-rate-cost-center.reducer';
import { IndirectRateRuleEffects } from './store/indirect-rate-rule/indirect-rate-rule.effects';
import * as fromIndirectRateRule from './store/indirect-rate-rule/indirect-rate-rule.reducer';
import { IndirectRateStructureEffects } from './store/indirect-rate-structure/indirect-rate-structure.effects';
import * as fromIndirectRateStructure from './store/indirect-rate-structure/indirect-rate-structure.reducer';
@NgModule({
    declarations: [
        IndirectRateContainerComponent,
        IndirectRateComponent,
        IndirectContainerComponent,
        IndirectRateCostCenterComponent,
        IndirectRateCostCenterContainerComponent,
        IndirectRateStructureContainerComponent,
        IndirectRateStructureComponent,
        IndirectRateRuleContainerComponent,
        IndirectRateRuleComponent,
        IndirectRateManagementContainerComponent,
        IndirectRateManagementPresenterComponent,
        IndirectRateReviewContainerComponent,
        IndirectRateReviewPresenter,
        IndirectRateHistoryContainerComponent,
        IndirectRateHistoryPresenter,
    ],
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(
            fromIndirectRateCostCenter.indirectRateCostCentersFeatureKey,
            fromIndirectRateCostCenter.reducer
        ),
        StoreModule.forFeature(
            fromIndirectRateStructure.indirectRateStructuresFeatureKey,
            fromIndirectRateStructure.reducer
        ),
        StoreModule.forFeature(
            fromIndirectRateRule.indirectRateRulesFeatureKey,
            fromIndirectRateRule.reducer
        ),
        EffectsModule.forFeature([
            IndirectRateCostCenterEffects,
            IndirectRateStructureEffects,
            IndirectRateRuleEffects
        ]),
        UIRouterModule.forChild({
            states: [
                IndirectRoute,
                IndirectRateRoute,
                IndirectRateManagementRoute,
                IndirectRateHistoryRoute
            ]
        })
    ]
})
export class IndirectRateModule {}
